import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output, DestroyRef, inject} from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

@Component({selector: 'app-steps',
  templateUrl: './steps.component.html',
  styleUrls: ['./steps.component.scss'],
  standalone: false,
})
export class StepsComponent implements OnInit {
  private destroyRef = inject(DestroyRef)
  /** Is the step move state is without routing but only click and event emit */
  @Input() withoutRouting: boolean = true;

  /** Steps list */
  @Input() items: MenuItem[];

  /** Steps wrapper additional styling */
  @Input() style: Record<string, string>;

  /** Step click output emits when click on step and the component is without routing */
  @Output() stepOnClick = new EventEmitter<number>();

  /** Active index of step */
  activeIndex: number = 0;



  constructor(private router: Router) {}

  ngOnInit(): void {
    if (!this.withoutRouting) {
      this.updateItems();
      this.router.events
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((data) => {
          const url = (data as { url?: string }).url
          if (url) {
            const pageName: string = url.split('/')[3];
            switch (pageName) {
              case 'about-your-business': {
                this.addStyleClassToStepItems('', 0, this.items.length);
                break;
              }
              case 'business-type': {
                if (localStorage.getItem('about-your-business-form')) {
                  this.addStyleClassToStepItems('finished', 0, 1);
                  this.addStyleClassToStepItems('', 1, this.items.length);
                }
                break;
              }
              case 'your-needs': {
                if (localStorage.getItem('selected-business-field')) {
                  this.addStyleClassToStepItems('finished', 0, 2);
                }
                this.addStyleClassToStepItems('', 2, this.items.length);

                break;
              }
              default: {
                localStorage.clear();
                break;
              }
            }
          }
        });
    }

    this.items[0].styleClass = 'active';
  }


  /**
   * Update items
   */
  updateItems() {
    if (!localStorage.getItem('items')) {
      //  this.initMenuItems();
      localStorage.setItem('items', JSON.stringify(this.items));
    } else {
      if (this.items) {
        localStorage.setItem('items', JSON.stringify(this.items));
      } else {
        this.items = JSON.parse(localStorage.getItem('items') ?? 'null') as MenuItem[];
      }
    }
  }

  /**
   * Add style class to menu items
   * @param styleClass Style class empty or finished
   * @param startIndex Start index
   * @param endIndex End index
   */
  addStyleClassToStepItems(
    styleClass: string,
    startIndex: number,
    endIndex: number
  ) {
    for (let i = startIndex; i < endIndex; i++) {
      this.items[i].styleClass = styleClass;
    }
    this.updateItems();
  }

  /**
   * When step active index changed check for
   * @param index
   */
  stepActiveIndexChange(index: number) {
    this.stepOnClick.emit(index);

    if (!this.items[index].disabled && index < this.activeIndex) {
      this.items[this.activeIndex].styleClass = '';
      this.items[index].styleClass = 'active';
    } else {
      this.addStyleClassToStepItems('finished', 0, index);
      this.items[index].styleClass = 'active';
    }
    this.activeIndex = index;
  }
}
